import { useTranslation } from "react-i18next";
import styles from "./styles/PosServices.module.css";

import ButtonService from "./ButtonService";

/**
 * The services form component for services POS
 */
const PosServicesForm = ({ services }) => {
    const { t } = useTranslation();

    return (
        <div className={`${styles.main_form_container} v-flex-container`}>
            <div className={`${styles.form_header_container} flex-container`}>
                <h1 className={`${styles.form_header}`}>{t(`services`)}</h1>
            </div>
            <div className={`flex-container`}>
                <div
                    className={`${styles.form_buttons_container} flex-container`}
                >
                    {services && services.length > 0 ? (
                        services.map((service) => (
                            <div
                                key={service?.serviceID}
                                className={`${styles.button_container} flex-container`}
                            >
                                <ButtonService
                                    body={service?.name}
                                    serviceId={service?.serviceID}
                                    price={service?.totalAmount}
                                />
                            </div>
                        ))
                    ) : (
                        <h3 className={`${styles.form_message}`}>
                            {t("no services available")}
                        </h3>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PosServicesForm;
